import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  toast,
} from '@kalos/ui';
import { type FC } from 'react';

import { NoteForm } from '../NotesForm/UploadMemoForm';

export interface AddJobNoteModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  loggedUserId: number;
  /** Target job (`eventId`); required to create a memo. */
  jobId?: number;
  /** When set, called on successful create instead of the default success toast */
  onSuccess?: () => void | Promise<void>;
}

export const AddJobNoteModal: FC<AddJobNoteModalProps> = ({
  open,
  onOpenChange,
  loggedUserId,
  jobId,
  onSuccess,
}) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent
      className="max-h-[90vh] max-w-md overflow-y-auto bg-white"
      style={{ clipPath: 'inset(0px round 20px)' }}
    >
      <DialogHeader>
        <DialogTitle>Add Job Note</DialogTitle>
        <DialogDescription>
          Create a note with optional attachments or audio for this job.
        </DialogDescription>
      </DialogHeader>
      {jobId != null && jobId > 0 ? (
        <NoteForm
          key={`${open}-${jobId}`}
          showCancelButton
          onClose={() => onOpenChange(false)}
          onSuccess={() => {
            if (onSuccess) {
              void Promise.resolve(onSuccess());
            } else {
              toast({
                title: 'Note added successfully',
                description: 'Your note has been saved',
              });
            }
          }}
          loggedUserId={loggedUserId}
          jobId={jobId}
        />
      ) : (
        <p className="text-sm text-gray-600">
          Select a job in the filters above to add a note to a specific job.
        </p>
      )}
    </DialogContent>
  </Dialog>
);
